import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import ListMetrics from './ListMetrics';
import { Button } from '../../Button';
import useIsMobile from '../../Utils/customHooks/useIsMobile';
import moduleStyles from '@dtsl/css-list/dist/index.module.css';
function ListMidSection(props) {
  const {
    content = null,
    mobileViewMetaData,
    isMetricEmpty = false,
    emptyMetricMessage = '',
    midSectionClassName = '',
    metricsClassName = '',
    isLoading = false,
    style = {}
  } = props;
  const {
    isMobile: isMobileView
  } = useIsMobile(640);
  const {
    isMobile: isTabletView
  } = useIsMobile(1024);
  const listMidSectionClasses = classNames({
    [moduleStyles['sib-list__stats']]: true,
    [moduleStyles['sib-list__stats-sm']]: isTabletView,
    [moduleStyles['sib-list__stats-xs']]: isMobileView,
    [midSectionClassName]: !!midSectionClassName
  });
  if (isLoading) {
    return /*#__PURE__*/React.createElement("div", {
      className: listMidSectionClasses,
      style: style
    });
  }
  const metricContent = ! /*#__PURE__*/React.isValidElement(content) ? /*#__PURE__*/React.createElement(ListMetrics, {
    content: content,
    metricsClassName: metricsClassName,
    isMetricEmpty: isMetricEmpty,
    emptyMetricMessage: emptyMetricMessage,
    isDesktopView: !isTabletView
  }) : content;
  return /*#__PURE__*/React.createElement("div", {
    className: listMidSectionClasses,
    style: style
  }, !isTabletView ? metricContent : /*#__PURE__*/React.createElement(Button, {
    id: "stats-info",
    icon: mobileViewMetaData?.icon,
    ariaLabel: mobileViewMetaData?.title,
    iconAlone: true,
    label: "Button",
    hasPopover: true,
    variant: "tertiary",
    popoverData: {
      trigger: ['click'],
      placement: 'bottom-end',
      title: mobileViewMetaData?.title,
      content: metricContent
    }
  }));
}
ListMidSection.propTypes = {
  content: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    percentCompletion: PropTypes.string,
    isValueLink: PropTypes.bool,
    helpButtonData: PropTypes.object,
    valueUrl: PropTypes.string,
    valueLinkProps: PropTypes.object,
    helpButtonDescInMobile: PropTypes.string,
    id: PropTypes.string
  }))]),
  mobileViewMetaData: PropTypes.shape({
    icon: PropTypes.node,
    title: PropTypes.string
  }),
  emptyMetricMessage: PropTypes.string,
  isMetricEmpty: PropTypes.bool,
  midSectionClassName: PropTypes.string,
  metricsClassName: PropTypes.string,
  isLoading: PropTypes.bool,
  style: PropTypes.object
};
export default ListMidSection;